import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\">\n\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t<rect width=\"24\" height=\"24\" rx=\"2\" />\n\t\t<path fill=\"currentColor\" d=\"M11 3a8 8 0 0 1 6.32 12.905l3.387 3.388a1 1 0 0 1-1.32 1.497l-.094-.083-3.388-3.386A8 8 0 1 1 11 3Zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol